import React from 'react';
import { ServiceOffering } from './TheOffering.service';
import { ProductOffering } from './TheOffering.product';

/**
 * MixedOffering renders both the service and product views stacked vertically.
 * Used when a site has offering_type === 'mixed'.
 */
export function MixedOffering() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-lg font-semibold mb-4">Services</h2>
        <ServiceOffering />
      </div>
      <div>
        <h2 className="text-lg font-semibold mb-4">Products</h2>
        <ProductOffering />
      </div>
    </div>
  );
}
